export default __webpack_public_path__ + "static/media/baa8ed402f94d9a883eba49302829197.jpg";